// // 自由项相关处理
// import {FreeItemsProcessor} from '../domain/retail/FreeItemsProcessor'



// const controllerLogList = [FreeItemsProcessor];
// export {controllerLogList}